import Http from "../../common/utils/Http";

export const conditionList = async () => {
    try {
        return await Http.get('home/content/conditions');
    } catch (error) {
        throw error;
    }
}
